// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadcrumbUi-module__breadcrumb__dLM0G"};